<template>
  <div class="fields-panel">
    <table class="fields-table">
      <thead>
        <tr>
          <th></th>
          <th>Campo</th>
          <th>Alias</th>
          <th>Orden</th>
          <th>Tooltip</th>
          <th>Reporte</th>
          <th>Título</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(row, i) in rows"
          :key="i"
          :class="{
            selected: row.visible,
            disabled: !row.visible
          }"
        >
          <td>
            <input type="checkbox" v-model="row.visible" @change="emitUpdate" />
          </td>

          <td class="field-name">{{ row.name }}</td>

          <td>
            <input
              class="input"
              type="text"
              v-model="row.alias"
              placeholder="Alias"
              :disabled="!row.visible"
              @input="emitUpdate"
            />
          </td>

          <td>
            <input
              class="input"
              type="number"
              v-model.number="row.order"
              :disabled="!row.visible"
              @input="emitUpdate"
            />
          </td>

          <td><input type="checkbox" v-model="row.tooltip" :disabled="!row.visible" @change="emitUpdate" /></td>
          <td><input type="checkbox" v-model="row.reporte" :disabled="!row.visible" @change="emitUpdate" /></td>
          <td><input type="checkbox" v-model="row.titulo" :disabled="!row.visible" @change="emitUpdate" /></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "FormularioArcgisPaso2", 
  props: {
    value: { 
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      rows: [],
    };
  },

  created() {
    this.initRows();
  },

  watch: {
    value: {
      handler() {
        this.initRows();
      },
      deep: true, 
      immediate: true,
    },
  },

  methods: {
    initRows() {
      if (!this.value || this.value.length === 0) {
        this.rows = [];
        return;
      }
      
      this.rows = this.value.map((f) => {
        if (typeof f === "string") {
          return {
            name: f,
            alias: "",
            order: 1,
            visible: true,
            tooltip: false,
            reporte: false,
            titulo: false,
          };
        }
        return {
          name: f.name || "",
          alias: f.alias || "",
          order: f.order || 1,
          visible: !!f.visible,
          tooltip: !!f.tooltip,
          reporte: !!f.reporte,
          titulo: !!f.titulo,
        };
      });
    },
    
    emitUpdate() {
        this.$emit('input', this.rows);
    }
  },
};
</script>

<style scoped>
.fields-panel {
  background: #f3f3f3;
  padding: 15px;
  border-radius: 8px;
  max-height: 350px;
  overflow-y: auto;
  border: 1px solid #ddd;
}

.fields-table {
  width: 100%;
  border-collapse: collapse;
}

.fields-table th {
  font-weight: bold;
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ccc;
}

.fields-table tbody tr {
  background: #efefef;
  transition: background 0.2s ease, opacity 0.2s ease;
}

.fields-table tbody tr.selected {
  background: #ffffff !important;
  border-left: 3px solid #187bcd;
}

.fields-table tbody tr.disabled {
  opacity: 0.6;
}

.fields-table td {
  padding: 8px;
}

.field-name {
  color: #555;
}

.input {
  width: 100%;
  padding: 6px;
  border: 1px solid #bbb;
  background: #fff;
  border-radius: 4px;
}

.input:disabled {
  background: #e9ecef;
  cursor: not-allowed;
}

.fields-table tbody tr.disabled input[type="checkbox"]:not(:first-child) {
  cursor: not-allowed;
}
</style>
